var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("titles.product-groups")))]),
      _c(
        "w-card-content",
        [
          _vm.useSimpleGroups
            ? [
                _vm.simplePath
                  ? _c(
                      "w-row",
                      [
                        _c("w-col", { attrs: { xs: "12" } }, [
                          _vm._v(" " + _vm._s(_vm.simplePath) + " "),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm._l(_vm.groups, function (group) {
                return _c(
                  "w-row",
                  { key: group.ID },
                  [
                    _c("w-col", { attrs: { xs: "12" } }, [
                      _vm._v(" " + _vm._s(group.getPath()) + " "),
                    ]),
                  ],
                  1
                )
              }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }